import { supabase } from '../client/supabaseClient';

/**
 * Interface representing a print job record from the database
 * based on the get_print_jobs RPC
 */
export interface PrintJob {
  user_name: string;
  shop_name: string;
  date: string;
  filename: string;
  amount: number;
  file_url: string;
  status: string;
}

/**
 * Fetches all print jobs from the database using the get_print_jobs RPC call.
 */
export async function fetchPrintJobs() {
  try {
    const { data, error } = await supabase
      .schema('api')
      .rpc('get_print_jobs');

    if (error) {
      console.error('Error fetching print jobs:', error);
      throw error;
    }

    return data as PrintJob[];
  } catch (error) {
    console.error('Unexpected error in fetchPrintJobs:', error);
    throw error;
  }
}
